export enum ActivityType {
    biometrics = 'biometrics',
    consultation = 'consultation',
    glaucoma = 'glaucoma',
    grading = 'grading',
    qualityControl = 'qualityControl',
    request = 'request',
}
